var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 42a1.5 1.5 0 01-1.061-.439L2.379 28.5 4.5 26.379l11.854 11.854L43.229 3.4 45.6 5.229 17.688 41.416A1.5 1.5 0 0116.6 42h-.1z",
    fill: "#73af00"
  })));
}

export default SvgCheckSingle;